export type ActivityType = Following | NotFollowing

export const following = 'following'
export type Following = typeof following
export const notFollowing = 'not-following'
export type NotFollowing = typeof notFollowing

const oppositeMap = {
  following: 'not-following',
  'not-following': 'following',
} as const satisfies Record<ActivityType, ActivityType>

export const opposite = <T extends ActivityType>(type: T) => oppositeMap[type]
